import {VoteState} from '@colonist/game-state-types'
import {StateCreator} from 'zustand'

export interface GameVoteSlice {
    gameVote: {
        voteState: VoteState | undefined
        setVoteState: (voteState: VoteState | undefined) => void
        onVoteAccept: (voteId: number) => void
        onVoteReject: (voteId: number) => void
    }
}

export interface GameVoteSliceProps {
    initialVoteState?: VoteState
    onVoteAccept: (voteId: number) => void
    onVoteReject: (voteId: number) => void
}

export const createGameVoteSlice = ({
    initialVoteState,
    onVoteAccept,
    onVoteReject,
}: GameVoteSliceProps): StateCreator<GameVoteSlice> => (set, get) => ({
    gameVote: {
        voteState: initialVoteState,
        setVoteState: (voteState) => {
            set({gameVote: {
                ...get().gameVote,
                voteState: voteState,
            }})
        },
        onVoteAccept: onVoteAccept,
        onVoteReject: onVoteReject,
    },
})
